import { createContext, JSXElement, mergeProps, useContext } from 'solid-js';
import { createStore } from 'solid-js/store';
import FSAOnboardingModal from '~/pages/FSAOnboarding/FSAOnboardingModal.tsx';
import FSAOnboardingWarningModal from '~/pages/FSAOnboarding/FSAOnboardingWarningModal.tsx';
import FSADeactivateWarningModal from '~/pages/FSAOnboarding/FSADeactivateWarningModal.tsx';
import { ToastContextProvider } from '~/components/ui/Toast';

const FSAModalContext = createContext();

type FSAModalContextValueType = {
  isFSAOnboardingModalOpen: boolean;
  isFSADeactivateWarningModalOpen: boolean;
  openFSAOnboardingModal: () => void;
  openFSADeactivateWarningModal: () => void;
  hideFSAOnboardingModal: () => void;
  hideFSADeactivateWarningModal: () => void;
  isFSAOnboardingWarningModalOpen: boolean;
  openFSAOnboardingWarningModal: () => void;
  hideFSAOnboardingWarningModal: () => void;
};

type FSAModalContextProps = {
  children: JSXElement;
};

export default function FSAModalContextProvider(
  props: FSAModalContextProps
): JSXElement {
  const merged = mergeProps({}, props);
  const [data, setData] = createStore<FSAModalContextValueType>({
    isFSAOnboardingModalOpen: false,
    isFSADeactivateWarningModalOpen: false,
    openFSAOnboardingModal: () => {
      setData('isFSAOnboardingModalOpen', true);
    },
    openFSADeactivateWarningModal: () => {
      setData('isFSADeactivateWarningModalOpen', true);
    },
    hideFSAOnboardingModal: () => {
      setData('isFSAOnboardingModalOpen', false);
    },
    hideFSADeactivateWarningModal: () => {
      setData('isFSADeactivateWarningModalOpen', false);
    },
    isFSAOnboardingWarningModalOpen: false,
    openFSAOnboardingWarningModal: () => {
      setData('isFSAOnboardingWarningModalOpen', true);
    },
    hideFSAOnboardingWarningModal: () => {
      setData('isFSAOnboardingWarningModalOpen', false);
    }
  });

  return (
    <FSAModalContext.Provider value={data}>
      <ToastContextProvider>
        <FSAOnboardingModal />
        <FSAOnboardingWarningModal />
        <FSADeactivateWarningModal />
        {merged.children}
      </ToastContextProvider>
    </FSAModalContext.Provider>
  );
}

const useFSAModalContext = (): FSAModalContextValueType =>
  useContext(FSAModalContext) as FSAModalContextValueType;

export { useFSAModalContext };
